export function getWebhookEventNames(isNotificationWebhookEnabled: boolean) {
  return [
    'client.created',
    'client.deleted',
    'client.updated',
    'client.customFields.updated',
    'client.activated',
    'company.created',
    'company.updated',
    'company.deleted',
    'form_response.completed',
    'file.created',
    'file.updated',
    'file.deleted',
    'folder.created',
    'folder.updated',
    'folder.deleted',
    'link.created',
    'link.updated',
    'link.deleted',
    'message.sent',
    'contract.signed',
    'contract.requested',
    ...(isNotificationWebhookEnabled ? ['notification.sent'] : []),
  ];
}
